import React, { Component } from 'react'
import TeamProfile from './cards/team-profile'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'

class TeamRepeater extends Component {

  render() {
    const { pageTeamRepeater, title, teamMembers, text, titleAlignment, button } = this.props;
    return (
      <section className={'team-repeater'} data-color={(pageTeamRepeater === "WFLanding" ? '#FFFFFF' : '#64656A')} id='team'>
        <div className={'team-repeater__inner'}>
          {title && <h4 className={`team-repeater__title ${titleAlignment !== 'left' ? 'team-repeater__title--margin-bottom' : ''}`} style={{ textAlign: titleAlignment }}>{title}</h4>}
          <div className={`team-repeater__list team-repeater__list--${titleAlignment}`}>
            {teamMembers?.map((el, i) => {
              return (
                <TeamProfile page={pageTeamRepeater} {...el} key={i} last={i + 1 === teamMembers.length} />
              )
            })}
          </div>
          {text && <p className='team-repeater__p'>{text}</p>}
          {button?.link &&
            <div className='team-repeater__btn '>
              <Link className='btn' to={button.link}>{button.text}</Link>
            </div>
          }
        </div>
      </section>
    )
  }
}


export default TeamRepeater
